<template>
  <div class="page-wrap page-layout-setting-detail">
    <!-- 详情 -->
    <jw-drawer :width="data.drawerWidth" :visible="data.visible" @cancel="handleCancel" unmount-on-close :footer="false" :header="false" :drawer-style="{ backgroundColor: 'var(--color-fill-2)' }" class="layout-details-content-drawer">
      <jw-spin :loading="loading" class="loading-content">
        <div class="header-content">
          <layout-header @cb="handleCancel" @saveLayout="saveLayout" :title="grayList['Layout:viewInit'] ? '详情页设置' : data.title" :loading="loading"> </layout-header>
        </div>
        <jw-row :gutter="20" justify="start" :class="['layout-form-content', splitType ? 'split-layout-content' : '']">
          <jw-col v-if="splitType === 3" :span="4" :class="['layout-form-left-content', splitType ? 'layout-form-split-content' : '']">
            <jw-card class="tree-data-content">
              <!-- <p class="tree-title">{{ $t('资源库') }}</p> -->

              <jw-tabs class="tree-tabs-content" hide-content v-model="activeKey" @change="handleChange">
                <jw-tab-pane key="fields" title="字段" />
                <jw-tab-pane key="components" title="组件" />
              </jw-tabs>
              <div class="tree-show-container">
                <div class="tree-handle-box">
                  <jw-input-search v-if="activeKey === 'fields'" size="small" v-model="searchFieldName" :placeholder="$t('请输入字段名称')" class="layout-detail-input" allow-clear> </jw-input-search>

                  <div class="tree-field-select" v-if="activeKey === 'fields'">
                    <div class="select-title">查看方式</div>
                    <jw-select
                      v-model="checkFieldType"
                      @change="changeCheckFieldType"
                      :options="[
                        { label: '按字段分组查看', value: 'fieldsGroup' },
                        { label: '按字段类型查看', value: 'fieldType' }
                      ]"
                    />
                  </div>
                </div>
                <xl-tree v-if="treeDataList.length" :options="treeDataList" @cb="getDetailData" :fieldsMap="fieldsMapCmp" :isRepeat="1" type="1"></xl-tree>
                <div class="tree-empty" v-else>
                  <jw-empty />
                </div>
              </div>
            </jw-card>
          </jw-col>
          <jw-col :span="splitType === 3 ? 15 : 19" :class="['layout-center-content', splitType ? 'split-center-content' : '']">
            <jw-card class="layout-detail-title">
              <jw-space>
                <jw-tag color="blue">{{ data.tagLabel }}</jw-tag>
                <jw-space @click.stop>
                  <span style="color: #1d2129">{{ $t('详情标题') }}</span>
                  <jw-select v-model="data.selectValue" :field-names="fieldNames" :options="data.optionsList" :style="{ width: '220px' }" :placeholder="$t('请选择标题')" size="small" @change="changeTitle" />
                </jw-space>
              </jw-space>
            </jw-card>

            <jw-row :gutter="10" justify="start">
              <jw-col :span="hasFollowModule || pId == 4 ? 18 : 24" class="abstract-detail-area" ref="layoutDetailAbstractRef">
                <div
                  :class="{
                    'abstract-detail-scroll-shadow-content': true,
                    'scroll-shadow-top-bg-show': scrollShow
                  }"
                ></div>
                <div class="abstract-detail-area-content scrollbar-style-config" ref="layoutDetailRef" @scroll="handleScroll" @mouseleave="mouseLeave">
                  <div class="layout-detail-abstract">
                    <abstract-area @sendData="sendData" :type="2" v-model:groupList="groupList"></abstract-area>
                  </div>
                  <tab-detail-area ref="tabAreaRef" @cb="scrollToBottom" @sendData="sendData" v-model:tabList="data.tabDetailList" :layoutId="layoutId"></tab-detail-area>
                </div>

                <div class="add-new-group-content" v-if="splitType === 3">
                  <div
                    :class="{
                      'scroll-shadow-content': true,
                      'scroll-shadow-bottom-bg-show': scrollShow
                    }"
                  ></div>
                  <div class="add-new-group" @click="addNewGroup(-1)">
                    <jw-link>{{ $t('添加新分组') }}</jw-link>
                  </div>
                </div>
              </jw-col>
              <jw-col :span="hasFollowModule || pId == 4 ? 6 : 0" class="abstract-detail-card-content">
                <jw-card
                  v-if="hasFollowModule"
                  class="collaborator hand"
                  @click="collaboratorConfig"
                  :class="{
                    'active-module': active === 'module' && data.activeModule === 1
                  }"
                >
                  <div>{{ $t('协作人') }}</div>
                  <div class="collaborator-content">
                    <div class="circle-container">
                      <div
                        class="circle"
                        :style="{
                          background: collaboratorDisplay ? '#B0D879' : 'var(--color-border-2)'
                        }"
                      >
                        <qfei-icon-user-outlined />
                      </div>
                      <div
                        class="circle"
                        :style="{
                          background: collaboratorDisplay ? '#7ED8D8' : 'var(--color-border-2)'
                        }"
                      >
                        <qfei-icon-user-outlined />
                      </div>
                      <div
                        class="circle"
                        :style="{
                          background: collaboratorDisplay ? '#67ACEF' : 'var(--color-border-2)'
                        }"
                      >
                        <qfei-icon-user-outlined />
                      </div>
                      <div
                        class="circle"
                        :style="{
                          color: collaboratorDisplay ? 'var(--color-border-3)' : '#fff'
                        }"
                      >
                        <qfei-icon-more-applications-outlined />
                      </div>
                    </div>
                    <div class="circle-memo">
                      {{ collaboratorDisplay ? $t('组件已启用') : $t('未启用协作人') }}
                    </div>
                  </div>
                </jw-card>
                <!-- 动态记录 -->
                <div class="follow-layout-detail">
                  <jw-card class="follow-card hand" :class="[active === 'module' && data.activeModule === 2 ? 'active-module' : '', [2, 3, 12, 13].includes(pId) ? 'isCollaborator' : 'noCollaborator']" @click="followRecordConfig(1)">
                    <div>{{ data.followtagLabel }}</div>
                    <div class="follow-record">
                      <jw-space :class="[followDisplay ? 'skeleton-variant-2' : 'skeleton-variant-4']" direction="vertical" :style="{ width: '100%' }" size="small">
                        <jw-skeleton-line :widths="['40%']" :rows="1" :line-height="8" />
                      </jw-space>
                      <div
                        class="follow-skeleton"
                        :class="[followDisplay ? 'skeleton-variant-2' : 'skeleton-variant-1']"
                        :style="{
                          background: followDisplay ? '#F7FBF1' : 'var(--color-fill-2)'
                        }"
                      >
                        <jw-space direction="vertical" :style="{ width: '100%' }" size="small">
                          <jw-skeleton-line v-for="(item, index) in data.skeletonWidths" :key="index" :widths="[item]" :rows="1" :line-height="8" />
                        </jw-space>
                      </div>
                      <jw-space :class="[followDisplay ? 'skeleton-variant-3' : 'skeleton-variant-4']" direction="vertical" :style="{ width: '100%' }" size="small">
                        <jw-skeleton-line :widths="['40%']" :rows="1" :line-height="8" />
                      </jw-space>
                      <div
                        class="follow-skeleton"
                        :class="[followDisplay ? 'skeleton-variant-3' : 'skeleton-variant-1']"
                        :style="{
                          background: followDisplay ? '#F2FBFB' : 'var(--color-fill-2)'
                        }"
                      >
                        <jw-space direction="vertical" :style="{ width: '100%' }" size="small">
                          <jw-skeleton-line v-for="(item, index) in data.skeletonWidths" :key="index" :widths="[item]" :rows="1" :line-height="8" />
                        </jw-space>
                      </div>
                      <div class="record-tip-big">
                        {{ followDisplay ? $t('组件已启用') : $t('未启用该组件') }}
                      </div>
                    </div>
                  </jw-card>
                </div>
              </jw-col>
            </jw-row>
          </jw-col>
          <jw-col :span="5" :class="['layout-config-area', splitType ? 'split-config-area' : '']">
            <layout-config-area :entity="pId" :name="form.name" @cb="updateConfig" ref="layoutConfigRef"></layout-config-area>
          </jw-col>
        </jw-row>
      </jw-spin>
    </jw-drawer>
  </div>
</template>

<script setup>
import { QfeiIconUserOutlined, QfeiIconMoreApplicationsOutlined } from '@qfei-design/icons-vue';
import { reactive, provide, computed, inject, ref, nextTick } from 'vue';
import LayoutHeader from '@/views/setting/sys-fields/page-layout/components/layout-header/layout-header.vue';
// import LayoutFieldSelect from '@/views/setting/sys-fields/page-layout/components/layout-field-select/layout-field-select.vue';
import LayoutConfigArea from '@/views/setting/sys-fields/page-layout/components/layout-config-area/layout-config-area.vue';
import AbstractArea from '@/views/setting/sys-fields/page-layout/components/abstract-area/abstract-area.vue';
import TabDetailArea from '@/views/setting/sys-fields/page-layout/components/tab-detail-area/tab-detail-area.vue';
import getLayoutFields from '@/hooks/layout';
// import { layoutBuiltObj } from '@/utils/const';
import { cloneDeep } from 'lodash';
import { setService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import useLoading from '@/hooks/loading';
// import useViewFields from '@/hooks/view-fields';
import { useI18n } from 'vue-i18n';
import setScrollBar from '@/hooks/scrollbar-config';
import { useRoute } from 'vue-router';
import { useGrayscaleStore } from '@/store';
import useObjectForm from '@/hooks/object-form';
const { getRecordType } = useObjectForm();

const { t } = useI18n();
const { loading, setLoading } = useLoading(false);
const { getFields, treeData, layoutEnableList, allBtnGroup, layoutTableBtnModules, getBtnCollection, tabComponent, getRecordList, searchRecordList, getFormDesign } = getLayoutFields();
const { scrollShow, handleScroll, mouseLeave } = setScrollBar();
const { grayList } = useGrayscaleStore(); //用户信息

const groupList = ref([{ type: '10', label: '', modules: [] }]);
const layoutDetailAbstractRef = ref(null);
const tabAreaRef = ref();
const emits = defineEmits(['cb']);

const layoutConfigRef = ref(); //右侧配置
const splitType = ref(null); // 布局分裂模式
const data = reactive({
  visible: false,
  title: '',
  tagLabel: '',
  followtagLabel: '',
  operationType: null,
  drawerWidth: '100%',
  sendType: {},
  saveType: null,
  tabDetailList: [],
  tabIndex: 0,
  area: '',
  fieldIndex: '',
  groupIndex: '',
  sonIndex: '',
  isShowCollaborator: 1,
  isShowFollow: 1,
  isShowFlowStageConfig: 1,
  btnConfigList: [],
  activeModule: null,
  optionsList: [],
  selectValue: '',
  tagAreaObj: [],
  sentTabLabel: [],
  showBtnCount: '2',

  buttonselectedList: [],
  followButtonSelected: [],
  collaButtonSelected: [],
  assQuickButtonSelected: {}, //关联对象表格快捷按钮
  skeletonWidths: ['60%', '30%', '100%', '80%'],
  fieldAttributeOutLayout: [],
  formAttribute: {} //表单设计中表单设置的属性
});

// const allButtonList = ref()
const layoutDetailRef = ref(null);
const activeKey = ref('fields');
const checkFieldType = ref('fieldsGroup');
const route = useRoute();
const props = defineProps({
  entity: {
    // 对象Id
    type: String,
    default: ''
  }
});
// 线索池查询使用线索的id
const pId = computed(() => (route.params?.id ? route.params.id : props.entity ? props.entity : '101'));
const form = ref({
  name: '',
  type: inject('layout')?.layoutId //布局类型
});
const searchFieldName = ref();
const updatedetailData = ref(); //从左侧拖拽到右边的数据
const getDetailData = (record) => {
  console.log('getDeatailInformation', record);
  updatedetailData.value = record;
};

//资源库切换
const handleChange = (key) => {
  console.log('key33', key);
  activeKey.value = key;
};

// 是否显示协作人
const hasFollowModule = computed(() => {
  return [1, 2, 3, 6, 8, 10, 12, 13, 101].includes(pId.value) || Number(pId.value) >= 200;
});
const scrollToBottom = () => {
  nextTick(() => {
    layoutDetailAbstractRef.value.$el.scrollTop = layoutDetailAbstractRef.value.$el.scrollHeight;
  });
  console.log(176, layoutDetailAbstractRef.value);
};
// 关闭弹窗
const handleCancel = () => {
  form.value.name = '';
  data.visible = false;
  layoutId.value = '';
  data.activeModule = null;
  activeKey.value = '';
  checkFieldType.value = '';
  emits('cb');
};
const layoutId = ref(); //视图id
const copyIsSave = ref(false); //复制--保存
const fieldNames = { value: 'fieldKey', label: 'fieldName' };
// 改变下拉框
const changeTitle = (value) => {
  console.log('value', value);
  data.tagAreaObj = data.optionsList
    .filter((v) => v.fieldKey === value)
    .map((item) => {
      return {
        label: item.fieldName,
        value: item.fieldKey,
        isRequired: item.isRequired ? 1 : 0,
        type: '20'
      };
    });
  console.log(140, data.tagAreaObj);
};
// 添加新分组
const addNewGroup = () => {
  tabAreaRef?.value?.addNewGroup();
  nextTick(() => {
    layoutDetailRef.value.scrollTop = layoutDetailRef.value.scrollHeight;
  });
};
// 重置一些数据
const resetData = () => {
  followDisplay.value = 0;
  followDisplayConditions.value = null;
  activeKey.value = 'fields';
  checkFieldType.value = 'fieldsGroup';
};
// 获取字段列表
const getFieldsList = async () => {
  await getFields({ id: pId.value, fieldName: searchFieldName.value, type: 2 });
};

// 打开弹窗
const openDialog = async (params) => {
  // 清空搜索值
  setLoading(true);
  splitType.value = null; //需要先清空一下，以免打开弹窗后，splitType的值没有清空
  data.visible = true;

  resetData();
  // 详情中标签名称接口
  await getSysObjEnumList();
  await getSysObjEnumListFollow();
  searchFieldName.value = '';
  data.title = params?.title || '';
  data.sendType = {};
  data.operationType = params?.operationType; //1:新建0：编辑2：复制
  splitType.value = params?.splitType; // 分裂模式 2未分裂 3 分裂
  await getFieldsList();
  data.optionsList = layoutEnableList.value.filter((v) => v.fieldType == 0 || v.fieldType == 13);
  if (data.optionsList?.length > 0) {
    data.selectValue = data.optionsList?.[0]?.fieldKey;
    changeTitle(data.selectValue);
  }
  if (params.operationType == 0 || params.operationType == 2) {
    //编辑和复制
    copyIsSave.value = false;
    layoutId.value = params.id;
  } else {
    //新增
    form.value.name = '';
  }
  await getDetail();
  await getFieldsGroupInfo();

  getBtnCollection({
    entity: pId.value,
    position: '5',
    type: '150',
    buttonselectedList: data.buttonselectedList,
    source: 20 //详情
  });
};

// 获取所有按钮
const firstType = ref(1); //布局详情
const getDetail = async () => {
  let url;
  if (data.operationType == 1) {
    //新增---初始化
    url = setService.layoutInit({ type: form.value.type, entity: pId.value });
  } else {
    //编辑，复制
    url = setService.layoutDetail({ id: layoutId.value });
  }
  try {
    const json = await url;
    data.fieldAttributeOutLayout = json.result.white?.split(',') || [];
    data.formAttribute = json.result?.formAttribute || {}; //这里是表单设计中表单设置的属性
    // data.formAttribute = { ...json.result?.formAttribute, formLayout: 0, displayOneLine: 1 }; //这里是表单设计中表单设置的属性

    if (data.fieldAttributeOutLayout.length) {
      data.fieldAttributeOutLayout = data.fieldAttributeOutLayout?.map((orgId) => Number(orgId));
    }
    if (json.error && json.error?.msg) {
      Message.error(json.error?.msg || t('操作失败'));
      return;
    }
    form.value.name = data.operationType == 2 ? json.result.name + '_' + t('复制') : json.result.name;
    const resultModules = json.result.modules;
    firstType.value = json.result.split;
    if (resultModules.length > 0) {
      await assignValue(resultModules);
    }

    setLoading(false);
  } catch (e) {
    console.log(e);
    setLoading(false);
  }
};
const operationId = ref();
const titleId = ref();
const abstractId = ref();
const tabId = ref();
const collaboratorId = ref();
const followId = ref();
const opId = ref();
const collaboratorDisplay = ref(1);
const followDisplay = ref(0);
const opDisplay = ref(1);
const followDisplayConditions = ref();
const followFeild = ref();
const fieldsGroupListInfo = ref([]); // 字段分组信息

//初始化左侧字段数据

const findLabel = (list, value) => {
  let label = null;
  for (let i = 0; i < list.length; i++) {
    if (list[i].value === value) {
      label = list[i].label;
    }
  }
  return label;
};

// 切换查看类型
const changeCheckFieldType = () => {
  searchFieldName.value = '';
};

const setRecordTreeData = () => {
  getRecordList(fieldsGroupListInfo.value);
  setCopyTreeData(); //备份原始数据用来搜索
};
const getFieldsGroupInfo = async () => {
  fieldsGroupListInfo.value = await getFormDesign(Number(pId.value));
  setCopyGroupTreeData();
  setRecordTreeData();
};

const fieldsMapCmp = computed(() => {
  const resultList = [];

  const asbFieldInfo = groupList.value[0]?.modules || []; // 避免 undefined
  const detailInfo = data.tabDetailList || []; // 避免 undefined

  console.log('详情页字段信息', detailInfo);

  // 使用扁平化方法处理嵌套数据
  const flattenModules = (modulesList, condition = () => true) => {
    return modulesList.flatMap((moduleItem) => {
      // 如果是 type 30(关联记录),31(查询记录)，直接跳过
      //     if (getRecordType(moduleItem.type)) {
      //     results.push(moduleItem);
      //   }
      const results = [];
      if (moduleItem.value && condition(moduleItem) && !moduleItem.nonFieldCount) {
        results.push(moduleItem);
      }
      if (moduleItem.type == 30 || moduleItem.type == 31) {
        if (moduleItem.modules?.length) {
          moduleItem.modules.forEach((ic) => (ic.nonFieldCount = true));
        }
      }
      if (moduleItem.modules?.length) {
        results.push(...flattenModules(moduleItem.modules, condition));
      }
      return results;
    });
  };

  // 处理detailInfo中的数据
  detailInfo.forEach((vItem) => {
    if (vItem.modules?.length) {
      resultList.push(...flattenModules(vItem.modules));
    }
  });

  // 摘要区字段处理
  asbFieldInfo.forEach((vItem) => {
    if (vItem.value && !getRecordType(vItem.type)) {
      resultList.push(vItem);
    }
  });

  const fieldsMap = new Map();
  resultList.forEach((item) => {
    const val = item.value;
    fieldsMap.set(val, (fieldsMap.get(val) || 0) + 1);
  });

  console.log('表格信息改动33', resultList, fieldsMap);
  return fieldsMap;
});

// const updateFieldsMap = () => {
//   // 先清空 map
//   fieldsMap.value.clear();
//   abstractDetailList.value.forEach((item) => {
//     const val = item.value;
//     fieldsMap.value.set(val, (fieldsMap.value.get(val) || 0) + 1);
//   });
// };

const treeDataList = computed(() => {
  if (activeKey.value == 'fields') {
    // 字段
    let getTreeDataList = null;
    if (checkFieldType.value === 'fieldType') {
      // 按字段类型查看

      if (!searchFieldName.value) {
        getTreeDataList = copyTreeData.value;
      } else {
        getTreeDataList = searchRecordList(copyTreeData.value, searchFieldName.value);
      }

      getTreeDataList = getTreeDataList?.filter((fItem) => fItem.fieldType != 100);

      return getTreeDataList;
    }
    if (checkFieldType.value === 'fieldsGroup') {
      // 按字段分组查看

      if (!searchFieldName.value) {
        getTreeDataList = copyGroupTreeData.value || [];
      } else {
        getTreeDataList = searchRecordList(copyGroupTreeData.value, searchFieldName.value);
      }

      //   const resultList = fieldsGroupListInfo.value?.map((fItem) => {
      //     return {
      //       ...fItem,
      //     //   children: fItem.children?.filter((child) => !getRecordType(child.type)) || []
      //     };
      //   });
      //   return resultList;
      return getTreeDataList;
    }
  } else if (activeKey.value == 'components') {
    // 组件
    return treeData.value?.filter((fItem) => fItem.fieldType >= 100);
  }

  return treeData.value?.filter((fItem) => fItem.fieldType >= 100);
});

const abstractDetailList = ref([]);
const copyTreeData = ref(null); //复制的树数据
const copyGroupTreeData = ref(null); //复制的树数据
const setCopyTreeData = () => {
  copyTreeData.value = cloneDeep(treeData.value);
};
const setCopyGroupTreeData = () => {
  copyGroupTreeData.value = cloneDeep(fieldsGroupListInfo.value);
};

const assignValue = async (array) => {
  try {
    // const getRecordKey = []; //记录所有的key值
    for (let i = 0; i < array.length; i++) {
      if (array[i].type == '240') {
        abstractId.value = array[i].id;
        for (let j = 0; j < array[i].modules.length; j++) {
          const m = array[i].modules[j];
          m.layoutFieldType = m.type;
          m.display = m.display || m.display == 0 ? m.display : 1; //添加默认值
          if (m.type == '20') {
            //联系方式
            // if (m.value === 'mobile') m.toast = t('tips.phoneNumberRules'); //提示
            const label = searchFieldName.value && searchFieldName.value !== '' ? m.label : findLabel(layoutEnableList.value, m.value);
            if (label) {
              m.label = label;
            } else {
              // 如果未找到最新label，则移除该字段
              array[i].modules.splice(j, 1);
              j--; // 更新索引
            }
            layoutEnableList.value.forEach((n) => {
              if (n.fieldKey == m.value) {
                m.fieldType = n.fieldType;
              }
            });
          } else if (m?.type == 60) {
            const _businessData = JSON.parse(m?.businessData);
            const _additionalBusiness = JSON.parse(m?.additionalBusiness);
            m.pcUrl = _businessData?.pcUrl ?? '';
            m.mobileUrl = _businessData?.mobileUrl ?? '';
            m.name = _additionalBusiness?.name ?? '';
            m.borderType = _additionalBusiness?.borderType ?? 'none';
            m.height = _additionalBusiness?.height ?? 0;
          }
        }

        groupList.value[0].modules = JSON.parse(JSON.stringify(array[i].modules));

        abstractDetailList.value.push(...array[i].modules);
      } else if (array[i].type == '250') {
        tabId.value = array[i].id;
        for (let j = 0; j < array[i].modules.length; j++) {
          for (let k = 0; k < array[i].modules[j].modules.length; k++) {
            for (let l = 0; l < array[i].modules[j].modules[k].modules?.length; l++) {
              const f = array[i].modules[j].modules[k].modules[l];

              f.layoutFieldType = f.type;
              f.display = f.display || f.display == 0 ? f.display : 1; //添加默认值
              if (f.type == '20' || f.type == '35') {
                abstractDetailList.value.push(f);

                //字段类型
                const label = searchFieldName.value && searchFieldName.value !== '' ? f.label : findLabel(layoutEnableList.value, f.value);
                if (label) {
                  f.label = label;
                } else {
                  // 如果未找到最新label，则移除该字段
                  array[i].modules[j].modules[k].modules.splice(l, 1);
                  l--; // 更新索引
                }
                layoutEnableList.value.forEach((n) => {
                  if (n.fieldKey == f.value) {
                    f.fieldType = n.fieldType;
                    if (f.fieldType == 27) {
                      const _modules = [];
                      //顺序塞入子字段
                      f?.modules?.map((fm) => {
                        const fmFind = n?.settings?.find((ns) => ns.fieldKey == fm.value);
                        if (fmFind) {
                          _modules.push({
                            ...fm,
                            layoutFieldType: '20',
                            display: fm?.display || 1,
                            label: fmFind?.fieldName,
                            value: fmFind?.fieldKey,
                            fieldType: fmFind?.fieldType,
                            displayOneLine: fm?.displayOneLine
                          });
                        }
                      });

                      f.modules = _modules;
                    }
                  }
                });
              } else if (f.type == 10) {
                //存在二级分组时
                for (let m = 0; m < array[i].modules[j].modules[k].modules[l].modules?.length; m++) {
                  const n = array[i].modules[j].modules[k].modules[l].modules[m];
                  n.layoutFieldType = n.type;
                  n.display = n.display || n.display == 0 ? n.display : 1; //添加默认值
                  if (n.type == '20' || n.type == '35') {
                    //字段类型
                    if (n.value === 'mobile') n.toast = t('tips.phoneNumberRules'); //提示
                  } else if (n?.type == 60) {
                    const _businessData = JSON.parse(n?.businessData);
                    const _additionalBusiness = JSON.parse(n?.additionalBusiness);
                    n.pcUrl = _businessData?.pcUrl ?? '';
                    n.mobileUrl = _businessData?.mobileUrl ?? '';
                    n.name = _additionalBusiness?.name ?? '';
                    n.borderType = _additionalBusiness?.borderType ?? 'none';
                    n.height = _additionalBusiness?.height ?? 0;
                  }
                  //   else if (getRecordType(n?.type)) {
                  //     //查询记录，关联记录

                  //     if (getRecordKey.indexOf(n.value) == -1 && n?.version == 1) {
                  //       //从表单设计新增
                  //       getRecordKey.push(n.value);
                  //       getRecordList(n);
                  //     }
                  //   }
                }
              } else if (f?.type == 60) {
                const _businessData = JSON.parse(f?.businessData);
                const _additionalBusiness = JSON.parse(f?.additionalBusiness);
                f.pcUrl = _businessData?.pcUrl ?? '';
                f.mobileUrl = _businessData?.mobileUrl ?? '';
                f.name = _additionalBusiness?.name ?? '';
                f.borderType = _additionalBusiness?.borderType ?? 'none';
                f.height = _additionalBusiness?.height ?? 0;
              }
              //   else if (getRecordType(f?.type)) {
              //     //查询记录，关联记录

              //     if (getRecordKey.indexOf(f.value) == -1 && f?.version == 1) {
              //       //从表单设计新增
              //       getRecordKey.push(f.value);
              //       getRecordList(f);
              //     }
              //   }
            }
          }
          const moduleItem = array[i].modules[j];
          const moduleValue = moduleItem?.value;

          if (moduleValue && tabComponent.value.includes(moduleValue)) {
            moduleItem.modules =
              moduleItem?.modules ||
              []
                .filter((item) => item.type === '40')
                ?.map((btnItem) => {
                  return {
                    label: btnItem.label,
                    value: btnItem.value,
                    type: btnItem.type,
                    showField: true
                  };
                });
          }
        }

        data.tabDetailList = JSON.parse(JSON.stringify(array[i].modules));
      } else if (array[i].type == '220') {
        // 头部信息配置
        titleId.value = array[i]?.id;
        data.showBtnCount = array[i].businessData ?? '2';
        data.selectValue = array[i].modules.filter((item) => item.type !== '40')[0]?.value;
        data.buttonselectedList = getbuttonResult(array[i].modules);
        changeTitle(data.selectValue);
        // data.tagAreaObj = [...data.tagAreaObj, ...data.buttonselectedList];
      } else if (array[i].type == '910') {
        operationId.value = array[i].id;
      } else if (array[i].type == '270') {
        collaboratorId.value = array[i].id;
        collaboratorDisplay.value = array[i]?.display;
        console.log(4180, array[i], collaboratorDisplay.value);
        // 协作人模块
        data.followButtonSelected = getbuttonResult(array[i].modules);
      } else if (array[i].type == '280') {
        followId.value = array[i].id;
        followDisplay.value = array[i]?.display;
        followDisplayConditions.value = array[i]?.displayConditions;
        followFeild.value = array[i]?.modules;
        data.collaButtonSelected = array[i].modules;
      } else if (array[i].type == '230') {
        opId.value = array[i].id;
        opDisplay.value = array[i]?.display;
      }
    }
  } catch (err) {
    console.log(err);
  }
};

const getbuttonResult = (buttonArray) => {
  return buttonArray
    .filter((item) => item.type === '40')
    .map((btnItem) => {
      return {
        label: btnItem.label,
        value: btnItem.value,
        type: btnItem.type,
        showField: true
      };
    });
};
// const processItems = async (params) => {
//   await getViewFields(params); //获取所有字段
//   console.log(195, enableList.value);
// };
// 获取面包屑副标题
const getSysObjEnumList = async () => {
  try {
    const res = await setService.getSysObjEnumList({ entityType: pId.value });
    if (!res.error) {
      data.tagLabel = res.result?.entityName;
    } else {
      Message.error(res?.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    console.log(182, e);
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};
const getSysObjEnumListFollow = async () => {
  try {
    const res = await setService.getSysObjEnumList({ entityType: 16 });
    if (!res.error) {
      data.followtagLabel = res.result?.entityName;
    } else {
      Message.error(res?.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    console.log(182, e);
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};
// 搜索查询

// 配置协作人
const collaboratorConfig = () => {
  active.value = 'module';
  data.activeModule = 1;
  data.sendType = {
    page: 20,
    area: 'module',
    modules: [
      {
        label: t('协作人'),
        value: 1,
        display: collaboratorDisplay.value,
        modules: data.followButtonSelected
      }
    ]
  };
};
// 配置动态记录--报价单历史报价
const followRecordConfig = (type) => {
  console.log('followDisplay.value', followDisplay.value);
  active.value = 'module';
  data.activeModule = 2;
  data.sendType = {
    page: 20,
    area: 'module',
    modules: [
      {
        label: type == 2 ? t('历史报价') : data.followtagLabel,
        value: 2,
        display: followDisplay.value,
        displayConditions: followDisplayConditions.value,
        modules: followFeild.value,
        controlType: type
      }
    ]
  };
};
// 配置商机阶段
// const flowStageConfig = () => {
//   console.log('flowStageConfig');
//   active.value = 'module';
//   data.activeModule = 3;
//   data.sendType = { page: 20, area: 'module', modules: [{ label: t('商机阶段'), value: 3, display: opDisplay.value }] };
// };
const active = ref();
// 传递参数
const sendData = (sendType) => {
  console.log('摘要区更新333', sendType);
  active.value = sendType.active;
  if (sendType.area == 'tab') {
    data.tabIndex = sendType.index;
  } else if (sendType.area == 'field') {
    data.groupIndex = sendType.groupIndex;
    data.fieldIndex = sendType.fieldIndex;
    data.sonIndex = sendType.sonIndex; //二级分组内下标
  }
  data.sendType = sendType; //配置类型
  console.log('配置信息更新333', groupList.value);
};

// 表单效验
const handleSubmit = () => {
  const getBasicConfig = layoutConfigRef.value?.sendBasicConfig();

  if (!getBasicConfig?.name) {
    Message.error(t('请输入布局名称'));
    return false;
  }
  //校验子表单必选字段
  let isEmptySub = false;
  let isTableError = false;
  let subNumber = 0;
  //校验外链容器
  let isErrorPcUrl = false;
  let isErrorMobileUrl = false;
  if (groupList.value?.[0]?.modules?.length) {
    groupList.value[0]?.modules?.map((gvm) => {
      if (gvm?.layoutFieldType == 60 || gvm?.type == 60) {
        const regexHttps = /^https/;
        if (gvm?.pcUrl && !regexHttps.test(gvm?.pcUrl)) {
          isErrorPcUrl = true;
        }
        if (gvm?.mobileUrl && !regexHttps.test(gvm?.mobileUrl)) {
          isErrorMobileUrl = true;
        }
      }
    });
  }
  data.tabDetailList.map((dt) => {
    dt?.modules?.map((dtm) => {
      if (dtm?.modules?.length) {
        dtm?.modules?.map((dtmm) => {
          if (dtmm?.layoutFieldType == 35 && !dtmm?.modules?.length) {
            isEmptySub = true;
            subNumber++;
          }
          if (getRecordType(dtmm.layoutFieldType)) {
            //查询记录，关联记录
            if ((dtmm.layoutFieldType == 30 && (!dtmm?.businessData || !dtmm?.associateKey)) || (dtmm.layoutFieldType == 31 && !dtmm?.businessData)) {
              isTableError = true;
            }
          }
          if (dtmm.type == 10) {
            //存在二级分组时
            dtmm?.modules?.map((levelMod) => {
              if ((levelMod?.layoutFieldType == 35 || levelMod?.type == 35) && !levelMod?.modules?.length) {
                isEmptySub = true;
                subNumber++;
              }
              if (getRecordType(levelMod?.layoutFieldType || levelMod?.type)) {
                //查询记录，关联记录

                const recordType = Number(levelMod.layoutFieldType || levelMod.type);

                if ((recordType == 30 && (!levelMod?.businessData || !levelMod?.associateKey)) || (recordType == 31 && !levelMod?.businessData)) {
                  isTableError = true;
                }
              }
            });
          }
          if (dtmm?.layoutFieldType == 60) {
            //必须是https网址，并且不能是烽火网址
            const regexHttps = /^https/;
            if (dtmm?.pcUrl && !regexHttps.test(dtmm?.pcUrl)) {
              isErrorPcUrl = true;
            }
            if (dtmm?.mobileUrl && !regexHttps.test(dtmm?.mobileUrl)) {
              isErrorMobileUrl = true;
            }
          }
          if (dtmm?.layoutFieldType == 31 && (!dtmm?.additionalBusiness || dtmm?.additionalBusiness == 0) && dtmm?.modules?.length > 0) {
            //查询表格---未开启多层级表格
            dtmm.modules = dtmm.modules.filter((item) => item.type != 31); //把多层级表格配置过滤掉
          }
        });
      }
    });
  });
  if (isErrorPcUrl) {
    Message.error(t('请输入正确的电脑端链接'));
    return false;
  }
  if (isErrorMobileUrl) {
    Message.error(t('请输入正确的移动端链接'));
    return false;
  }
  if (isEmptySub) {
    Message.error(t('请在子表单中至少添加一个自定义字段'));
    return false;
  }
  if (subNumber > 10) {
    Message.error(t('每个布局中最多只能添加10个子表单'));
    return false;
  }
  if (isTableError) {
    Message.warning(t('请完善组件的必填内容'));
    return;
  }
  // 调用验证函数
  const validationResult = validateFormItems();

  if (validationResult.hasEmptyTable) {
    // 发现检验规则没有通过，则不再继续后续操作
    return;
  }
  updateLayout(); //保存
};

//保存
const saveLayout = (type) => {
  // type:1---保存并关闭，type:2 保存
  data.saveType = type;

  handleSubmit();
};
// 提交时对数据的校验
const validateFormItems = () => {
  let hasEmptyTable = false;

  data.tabDetailList?.forEach((formItem) => {
    if (formItem?.modules?.length) {
      formItem.modules.forEach((module) => {
        if (module?.modules?.length) {
          module.modules.forEach((mItem) => {
            if (mItem?.layoutFieldType == 31 && mItem?.additionalBusiness == 1) {
              //查询表格---开启了多层级表格
              const gettableLeverModulue = mItem?.modules?.filter((item) => item.type == 31); //把多层级表格配置过滤出来

              if (!gettableLeverModulue || gettableLeverModulue?.length == 0) {
                //没有配置多层级表格
                Message.warning(t('请在查询记录中添加多层级表格！'));
                hasEmptyTable = true;
                return; // 跳出当前模块的循环
              }
            }
          });
        }
      });

      // 如果已经发现问题，跳出外层循环
      if (hasEmptyTable) {
        return;
      }
    }
  });

  return { hasEmptyTable };
};

const getFormatModules = (i) => {
  return {
    id: data.operationType == 0 && typeof i.id == 'number' ? i.id : undefined,
    parentId: data.operationType == 0 ? i.parentId : undefined,
    label: i.label,
    value: i.value,
    associateField: i?.associateField || undefined,
    associateKey: i?.associateKey || undefined,
    type: i.layoutFieldType || i?.type,
    display: i.display,
    toast: i.toast,
    memo: i.memo,
    displayOneLine: i?.displayOneLine,
    businessData:
      i?.layoutFieldType == 60 || i?.type == 60
        ? JSON.stringify({
            pcUrl: i?.pcUrl ?? '',
            mobileUrl: i?.mobileUrl ?? ''
          })
        : i?.businessData,
    additionalBusiness:
      i?.layoutFieldType == 60 || i?.type == 60
        ? JSON.stringify({
            name: i?.name ?? '',
            borderType: i?.borderType ?? 'none',
            height: i?.height ?? 200
          })
        : undefined,
    dataRange: i?.dataRange || 1,
    displayConditions: i?.displayConditions || null,
    dataRangeConditions: i?.dataRangeConditions || null,
    modules:
      (i.fieldType === 27
        ? i.modules.map((im) => {
            return getFormatModules(im);
          })
        : i.modules) || null
  };
};
const updateLayout = async () => {
  // 摘要区
  const abstract = groupList.value[0].modules?.map((i) => {
    if (i.modules && i.modules.length > 0) {
      i.modules.forEach((item) => {
        if (data.operationType != 0) {
          item.id = undefined;
          item.parentId = undefined;
        }
      });
    }
    // 是否展示
    if (i.displayConditions) {
      if (data.operationType != 0) i.displayConditions.id = undefined;
      if (i.displayConditions.children && i.displayConditions.children.length > 0) {
        i.displayConditions.children.forEach((item) => {
          if (data.operationType != 0) {
            item.id = undefined;
            item.parentId = undefined;
          }
        });
      }
    }
    // 数据范围
    if (i.dataRangeConditions) {
      if (data.operationType != 0) i.dataRangeConditions.id = undefined;
      if (i.dataRangeConditions.children && i.dataRangeConditions.children.length > 0) {
        i.dataRangeConditions.children.forEach((item) => {
          if (data.operationType != 0) {
            item.id = undefined;
            item.parentId = undefined;
          }
        });
      }
    }
    return getFormatModules(i);
  });
  // 页签区

  const tabDetailList = data.tabDetailList?.map((obj) => {
    obj.modules = obj.modules.map((module) => {
      // 字段配置

      module.modules = module.modules?.map((i) => {
        if (i.modules && i.modules.length > 0) {
          i.modules.forEach((item) => {
            if (data.operationType != 0) {
              item.id = undefined;
              item.parentId = undefined;
            }
          });
        }
        if (i.type == 10) {
          i.modules = i.modules?.map((ii) => {
            if (ii.modules && ii.modules.length > 0) {
              ii.modules.forEach((item) => {
                if (data.operationType != 0) {
                  item.id = undefined;
                  item.parentId = undefined;
                }
              });
            }
            // 是否展示
            if (ii.displayConditions) {
              if (data.operationType != 0) ii.displayConditions.id = undefined;
              if (ii.displayConditions.children && ii.displayConditions.children.length > 0) {
                ii.displayConditions.children.forEach((item) => {
                  if (data.operationType != 0) {
                    item.id = undefined;
                    item.parentId = undefined;
                  }
                });
              }
            }
            // 数据范围
            if (ii.dataRangeConditions) {
              if (data.operationType != 0) ii.dataRangeConditions.id = undefined;
              if (ii.dataRangeConditions.children && ii.dataRangeConditions.children.length > 0) {
                ii.dataRangeConditions.children.forEach((item) => {
                  if (data.operationType != 0) {
                    item.id = undefined;
                    item.parentId = undefined;
                  }
                });
              }
            }
            return {
              id: data.operationType == 0 && typeof ii.id == 'number' ? ii.id : undefined,
              parentId: data.operationType == 0 ? ii?.parentId : undefined,
              label: ii.label,
              value: ii.value,
              associateField: ii?.associateField || undefined,
              associateKey: ii?.associateKey || undefined,
              type: ii.layoutFieldType || ii?.type,
              display: ii.display || ii.display == 0 ? ii.display : 1,
              toast: ii?.toast || null,
              memo: ii?.memo || null,
              displayOneLine: ii?.displayOneLine,
              businessData: ii?.businessData || null,
              dataRange: ii?.dataRange || 1,
              displayConditions: ii?.displayConditions || null,
              dataRangeConditions: ii?.dataRangeConditions || null,
              additionalBusiness: ii?.layoutFieldType == 31 || ii?.type == 31 ? ii?.additionalBusiness || '0' : null, //是否多层级表格
              modules: ii?.modules || null
            };
          });
        }
        // 是否展示
        if (i.displayConditions) {
          if (data.operationType != 0) i.displayConditions.id = undefined;
          if (i.displayConditions.children && i.displayConditions.children.length > 0) {
            i.displayConditions.children.forEach((item) => {
              if (data.operationType != 0) {
                item.id = undefined;
                item.parentId = undefined;
              }
            });
          }
        }
        // 数据范围
        if (i.dataRangeConditions) {
          if (data.operationType != 0) i.dataRangeConditions.id = undefined;
          if (i.dataRangeConditions.children && i.dataRangeConditions.children.length > 0) {
            i.dataRangeConditions.children.forEach((item) => {
              if (data.operationType != 0) {
                item.id = undefined;
                item.parentId = undefined;
              }
            });
          }
        }
        return i.type == 10
          ? {
              id: data.operationType == 0 && typeof i.id == 'number' ? i.id : undefined,
              parentId: data.operationType == 0 ? i?.parentId : undefined,
              type: i.layoutFieldType || i?.type,
              label: i.label,
              value: i.value,
              modules: i?.modules || null
            }
          : {
              id: data.operationType == 0 && typeof i.id == 'number' ? i.id : undefined,
              parentId: data.operationType == 0 ? i?.parentId : undefined,
              label: i.label,
              value: i.value,
              associateField: i?.associateField || undefined,
              associateKey: i?.associateKey || undefined,
              type: i.layoutFieldType || i?.type,
              display: i.display || i.display == 0 ? i.display : 1,
              toast: i?.toast || null,
              memo: i?.memo || null,
              displayOneLine: i?.displayOneLine,
              businessData:
                i?.layoutFieldType == 60 || i?.type == 60
                  ? JSON.stringify({
                      pcUrl: i?.pcUrl ?? '',
                      mobileUrl: i?.mobileUrl ?? ''
                    })
                  : i?.businessData || null,
              dataRange: i?.dataRange || 1,
              displayConditions: i?.displayConditions || null,
              dataRangeConditions: i?.dataRangeConditions || null,
              additionalBusiness:
                i?.layoutFieldType == 31 || i?.type == 31
                  ? i?.additionalBusiness || '0'
                  : i?.layoutFieldType == 60 || i?.type == 60
                  ? JSON.stringify({
                      name: i?.name ?? '',
                      borderType: i?.borderType ?? 'none',
                      height: i?.height ?? 200
                    })
                  : null, //是否多层级表格
              modules: i?.modules || null
            };
      });
      return {
        id: module?.parentId && module?.id ? module.id : undefined,
        parentId: module?.parentId && module?.id ? module?.parentId : undefined,
        type: module.type,
        label: module.label,
        value: module.value,
        modules: module?.modules || null
      };
    });
    return {
      id: data.operationType == 0 ? obj?.id : undefined,
      parentId: data.operationType == 0 ? obj?.parentId : undefined,
      type: obj.type,
      label: obj.label,
      value: obj.value,
      display: obj.display,
      displayConditions: obj?.displayConditions || null,
      modules: obj?.modules || null
    };
  });
  // 按钮组
  const getBasicConfig = layoutConfigRef.value?.sendBasicConfig();
  data.showBtnCount = getBasicConfig.showBtnCountModel;
  const buttonselectedList = getBasicConfig?.layoutDetailBtnModules[150]?.modules
    ?.filter((el) => el?.showField)
    ?.map((item) => {
      return {
        label: item.label,
        type: item.type,
        value: item.value
      };
    });
  const params = {
    name: getBasicConfig.name,
    type: '20',
    entity: Number(pId.value),
    modules: [
      {
        id: (data.operationType == 0 && operationId?.value) || undefined,
        parentId: data.operationType == 0 ? 0 : undefined,
        type: '910', //操作区（布局名称）
        display: 1,
        label: getBasicConfig.name
      },
      {
        id: (data.operationType == 0 && titleId?.value) || undefined,
        parentId: data.operationType == 0 ? 0 : undefined,
        type: '220', //标题区(标签)
        display: 1,
        label: data.tagLabel,
        businessData: data.showBtnCount,
        modules: [...data.tagAreaObj, ...buttonselectedList]
      },
      {
        id: (data.operationType == 0 && abstractId?.value) || undefined,
        parentId: data.operationType == 0 ? 0 : undefined,
        display: 1,
        type: '240', //摘要区
        modules: abstract
      },
      {
        id: (data.operationType == 0 && tabId?.value) || undefined,
        parentId: data.operationType == 0 ? 0 : undefined,
        display: 1,
        type: '250', //页签区
        modules: tabDetailList
      },
      {
        id: (data.operationType == 0 && collaboratorId?.value) || undefined,
        parentId: data.operationType == 0 ? 0 : undefined,
        type: '270', //是否展示协作人模块
        display: hasFollowModule.value ? collaboratorDisplay.value : 2,
        modules: data.followButtonSelected
          ?.filter((el) => el?.showField)
          ?.map((item) => {
            return {
              label: item.label,
              type: item.type,
              value: item.value,
              id: item?.parentId && item?.id ? item.id : undefined,
              parentId: item?.parentId && item?.id ? item?.parentId : undefined
            };
          })
      },
      {
        id: (data.operationType == 0 && followId?.value) || undefined,
        parentId: data.operationType == 0 ? 0 : undefined,
        type: '280', //是否展示动态记录，历史报价
        display: pId.value == 16 ? 2 : followDisplay.value,
        modules: data.collaButtonSelected,
        displayConditions: followDisplayConditions.value
      }
    ]
  };
  if (pId.value === 3) {
    params.modules.push({
      id: (data.operationType == 0 && opId?.value) || undefined,
      parentId: data.operationType == 0 ? 0 : undefined,
      type: '230', //是否展示流程阶段
      display: [3].includes(pId.value) ? opDisplay.value : 2
    });
  }
  console.log('params', params);
  let url;
  if (data.operationType == 0 || (data.operationType == 1 && layoutId.value) || (data.operationType == 2 && layoutId.value && copyIsSave.value)) {
    //编辑或者新增/复制未保存关闭时
    params.id = layoutId.value;
    url = setService.layoutUpdate(params);
  } else {
    //新增，复制
    url = setService.layoutAdd(params);
  }
  setLoading(true);
  try {
    const json = await url;
    console.log(755, 34222, json);
    setLoading(false);
    if (json.error && json.error?.msg) {
      Message.error(json.error?.msg || t('操作失败'));
      return;
    }
    Message.success(t('操作成功'));
    if (data.saveType == 1) {
      handleCancel();
    } else {
      // 仅保存--不关闭
      data.visible = true;
      if ((data.operationType == 1 && !layoutId.value) || (data.operationType == 2 && !layoutId.value)) {
        //新增或者复制
        layoutId.value = json.result?.id; //新增成功之后返回id
        const resultModules = json.result.modules;
        if (resultModules.length > 0) {
          assignValue(resultModules);
        }
      }
      if (data.operationType == 2) {
        //复制成功之后再保存走编辑
        copyIsSave.value = true;
      } else if (data.operationType == 1) {
        //新增成功之后变为编辑
        data.operationType = 0;
      }
      if (data.operationType == 0 || (data.operationType == 1 && copyIsSave.value) || (data.operationType == 2 && layoutId.value && copyIsSave.value)) {
        //编辑或者新增/复制未保存关闭时
        getDetail();
      }
    }
  } catch (e) {
    console.log(e);
    setLoading(false);
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};

//配置区域的回调
const updateConfig = (item) => {
  //   console.log('updateConfig------', item);
  if (!item.area && item?.modules) {
    if (item.modules.layoutFieldType == 20) {
      //字段
      getModules(groupList.value, item.modules);
    }
    if (getRecordType(item.modules.layoutFieldType) || item.modules.layoutFieldType == 50) {
      //组件
      groupList.value[item.parentIndex].modules[item.index] = item.modules;
    }
  }
  if (item.area == 'tab') {
    data.tabDetailList[data.tabIndex] = item.modules;
  } else if (item.area == 'module') {
    const value = item.modules[0].value;
    const display = item.modules[0].display;
    const modules = item.modules[0].modules;
    const controlType = item.modules[0].controlType;

    if (value == 1) {
      collaboratorDisplay.value = display;

      // 协作人模块按钮参数
      if (display === 1) {
        data.followButtonSelected = modules;
      }
    } else if (value == 2) {
      followDisplay.value = display;

      if (display === 1 || display === 2) {
        data.collaButtonSelected = modules;
      }
      // 动态记录条件参数
      if (controlType == 1) {
        followDisplayConditions.value = item.modules[0].displayConditions;
        followFeild.value = item.modules[0].modules;
      }
    } else if (value == 3) {
      opDisplay.value = display;
    } else if (value == 4) {
      // const feildConfig = data.tagAreaObj.length ? data.tagAreaObj.find((item) => item.type === '20') : [];
      data.buttonselectedList = modules;
      // data.tagAreaObj = [feildConfig, ...modules];
    } else if (value == 5) {
      // 按钮数量控制
      data.showBtnCount = item.modules[0]?.controlValue;
    }
  } else if (item.area == 'field') {
    if (data.sonIndex > -1) {
      data.tabDetailList[data.tabIndex]?.modules?.[data.groupIndex]?.modules?.[data.sonIndex]?.modules?.forEach((f, i) => {
        if (i == item.index) {
          f = item.modules;
        }
      });
    } else {
      data.tabDetailList[data.tabIndex]?.modules?.[data.groupIndex]?.modules?.forEach((f, i) => {
        if (i == item.index) {
          f = item.modules;
        }
      });
    }
  }
};

//递归找到对应的modules；
const getModules = (list, item) => {
  list.map((m) => {
    if (m.modules && m.modules.length > 0) {
      getModules(m.modules, item);
    }
    if (m.value == item?.value) {
      //value是fieldKey
      m = item;
    }
  });
};
provide('sharedConfigData', {
  pId: computed(() => pId.value),
  sendType: computed(() => data.sendType),
  name: computed(() => form.value.name),
  source: 2,
  operationType: computed(() => data.operationType),
  tabIndex: computed(() => data.tabIndex),
  groupIndex: computed(() => data.groupIndex),
  sonIndex: computed(() => data.sonIndex),
  active: computed(() => active.value),
  showBtnCount: computed(() => data.showBtnCount),
  buttonselectedList: computed(() => data.buttonselectedList),
  followButtonSelected: computed(() => data.followButtonSelected),
  collaButtonSelected: computed(() => data.collaButtonSelected),
  assQuickButtonSelected: computed(() => data.assQuickButtonSelected),
  layoutDetailBtnModules: computed(() => layoutTableBtnModules.value),
  allBtnGroup: computed(() => allBtnGroup.value), //所有的按钮
  fieldAttributeOutLayout: computed(() => data.fieldAttributeOutLayout),
  splitType: computed(() => splitType.value), // 布局分裂模式
  formAttribute: computed(() => data.formAttribute) //表单属性
});

// 抛出方法
defineExpose({
  openDialog
});
</script>

<style scoped lang="less">
@import './object-setting-detail.less';
</style>
<style lang="less">
.layout-details-content-drawer {
  .arco-drawer-body {
    padding: 0;
  }
}

.loading-content {
  width: 100%;
  height: 100%;
}
</style>
